import React from 'react';
import { getImageTypeName } from '../../utils/portfolio/imageUtils';

const AIResultsSection = ({ 
  aiResults, 
  selectedImageType, 
  onImageTypeSelect,
  showBackgroundColorPicker,
  selectedBackgroundColor,
  onBackgroundColorChange,
  backgroundRemovedImageWithColor,
  onImagePreview, // AI 결과 비교 모달 콜백
  profileImageFile // 원본 이미지 파일 추가
}) => {
  // AI 결과가 없고 원본 이미지도 없으면 아무것도 표시하지 않음
  if (!aiResults && !profileImageFile) return null;

  const handleImageClick = (e, imageType) => {
    e.preventDefault();
    e.stopPropagation();
    if (onImagePreview && typeof onImagePreview === 'function') {
      // AI 결과가 없을 때는 원본만 있는 객체 전달
      const resultsToPass = aiResults || { originalFile: profileImageFile };
      onImagePreview(resultsToPass, imageType);
    }
  };

  const handleSelectionClick = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    onImageTypeSelect(type);
  };

  return (
    <div className="mt-3 p-2.5 bg-gray-50 rounded-lg border border-gray-200">
      <h4 className="label mb-2">사진 스타일 선택</h4>
      
      <div className="grid grid-cols-4 gap-2">
        {/* 원본 사진 - 항상 표시 (profileImageFile이 있으면) */}
        {(profileImageFile || aiResults?.originalFile) && (
          <div className={`rounded-lg overflow-hidden border-2 ${
            selectedImageType === 'original' ? 'border-blue-500' : 'border-gray-200 hover:border-gray-300'
          }`}>
            <div className="relative group" style={{ aspectRatio: '3/4' }}>
              {/* 이미지 - 크게보기용 */}
              <img 
                src={aiResults?.originalFile 
                  ? URL.createObjectURL(aiResults.originalFile)
                  : (profileImageFile ? URL.createObjectURL(profileImageFile) : '')
                } 
                alt="원본 사진" 
                className="w-full h-full object-cover cursor-zoom-in"
                style={{ objectPosition: 'center top' }}
                onClick={(e) => handleImageClick(e, 'original')}
              />
              
              {/* 선택 버튼 - 우상단에 배치 */}
              <button
                className={`absolute top-2 right-2 w-6 h-6 rounded-full border-2 ${
                  selectedImageType === 'original' 
                    ? 'bg-blue-500 border-blue-500' 
                    : 'bg-white border-gray-300 hover:border-blue-400'
                } flex items-center justify-center transition-all duration-200 shadow-sm`}
                onClick={(e) => handleSelectionClick(e, 'original')}
                title="이 이미지 선택"
              >
                {selectedImageType === 'original' && (
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                )}
              </button>
            </div>
            <div className="p-1.5 text-xs text-center bg-white">
              원본 사진
            </div>
          </div>
        )}

        {/* AI 화질개선 이미지 */}
        {aiResults?.gfpganFile && (
          <div className={`rounded-lg overflow-hidden border-2 ${
            selectedImageType === 'gfpgan' ? 'border-blue-500' : 'border-gray-200 hover:border-gray-300'
          }`}>
            <div className="relative group" style={{ aspectRatio: '3/4' }}>
              {/* 이미지 - 크게보기용 */}
              <img 
                src={URL.createObjectURL(aiResults.gfpganFile)} 
                alt="AI 화질개선" 
                className="w-full h-full object-cover cursor-zoom-in"
                style={{ objectPosition: 'center top' }}
                onClick={(e) => handleImageClick(e, 'gfpgan')}
              />
              
              {/* 선택 버튼 - 우상단에 배치 */}
              <button
                className={`absolute top-2 right-2 w-6 h-6 rounded-full border-2 ${
                  selectedImageType === 'gfpgan' 
                    ? 'bg-blue-500 border-blue-500' 
                    : 'bg-white border-gray-300 hover:border-blue-400'
                } flex items-center justify-center transition-all duration-200 shadow-sm`}
                onClick={(e) => handleSelectionClick(e, 'gfpgan')}
                title="이 이미지 선택"
              >
                {selectedImageType === 'gfpgan' && (
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                )}
              </button>
            </div>
            <div className="p-1.5 text-xs text-center bg-white">
              AI 화질개선
            </div>
          </div>
        )}
        
        {/* AI 배경제거 이미지 */}
        {aiResults?.gfpganBackgroundRemoverFile && (
          <div className={`rounded-lg overflow-hidden border-2 ${
            selectedImageType === 'gfpgan-bg-remover' ? 'border-blue-500' : 'border-gray-200 hover:border-gray-300'
          }`}>
            <div className="relative group" style={{ aspectRatio: '3/4' }}>
              {/* 이미지 - 크게보기용 */}
              <img 
                src={backgroundRemovedImageWithColor ? 
                  URL.createObjectURL(backgroundRemovedImageWithColor) : 
                  URL.createObjectURL(aiResults.gfpganBackgroundRemoverFile)
                } 
                alt="AI 배경제거" 
                className="w-full h-full object-cover cursor-zoom-in"
                style={{ objectPosition: 'center top' }}
                onClick={(e) => handleImageClick(e, 'gfpgan-bg-remover')}
              />
              
              {/* 선택 버튼 - 우상단에 배치 */}
              <button
                className={`absolute top-2 right-2 w-6 h-6 rounded-full border-2 ${
                  selectedImageType === 'gfpgan-bg-remover' 
                    ? 'bg-blue-500 border-blue-500' 
                    : 'bg-white border-gray-300 hover:border-blue-400'
                } flex items-center justify-center transition-all duration-200 shadow-sm`}
                onClick={(e) => handleSelectionClick(e, 'gfpgan-bg-remover')}
                title="이 이미지 선택"
              >
                {selectedImageType === 'gfpgan-bg-remover' && (
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                )}
              </button>
            </div>
            <div className="p-1.5 text-xs text-center bg-white">
              AI 배경제거
            </div>
          </div>
        )}
        
        {/* AI 흑백효과 이미지 */}
        {aiResults?.gfpganBackgroundRemoverBlackWhiteFile && (
          <div className={`rounded-lg overflow-hidden border-2 ${
            selectedImageType === 'gfpgan-bg-remover-bw' ? 'border-blue-500' : 'border-gray-200 hover:border-gray-300'
          }`}>
            <div className="relative group" style={{ aspectRatio: '3/4' }}>
              {/* 이미지 - 크게보기용 */}
              <img 
                src={URL.createObjectURL(aiResults.gfpganBackgroundRemoverBlackWhiteFile)} 
                alt="AI 흑백효과" 
                className="w-full h-full object-cover cursor-zoom-in"
                style={{ objectPosition: 'center top' }}
                onClick={(e) => handleImageClick(e, 'gfpgan-bg-remover-bw')}
              />
              
              {/* 선택 버튼 - 우상단에 배치 */}
              <button
                className={`absolute top-2 right-2 w-6 h-6 rounded-full border-2 ${
                  selectedImageType === 'gfpgan-bg-remover-bw' 
                    ? 'bg-blue-500 border-blue-500' 
                    : 'bg-white border-gray-300 hover:border-blue-400'
                } flex items-center justify-center transition-all duration-200 shadow-sm`}
                onClick={(e) => handleSelectionClick(e, 'gfpgan-bg-remover-bw')}
                title="이 이미지 선택"
              >
                {selectedImageType === 'gfpgan-bg-remover-bw' && (
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                )}
              </button>
            </div>
            <div className="p-1.5 text-xs text-center bg-white">
              AI 흑백효과
            </div>
          </div>
        )}
      </div>
      <p className="text-xs text-gray-500 mt-2">
        이미지를 클릭하면 크게 보며 비교할 수 있습니다. 현재 선택: <span className="font-medium">{getImageTypeName(selectedImageType)}</span>
      </p>
      
      {/* 배경 색상 선택기 */}
      {showBackgroundColorPicker && (
        <div className="mt-2 p-2.5 bg-blue-50 border border-blue-200 rounded-lg">
          <h5 className="text-sm font-medium text-gray-900 mb-1.5">배경 색상 선택</h5>
          
          <div className="flex items-center gap-2 mb-2">
            <label className="text-xs text-gray-600">배경 색상:</label>
            <div className="flex items-center gap-2">
              <input 
                type="color" 
                value={selectedBackgroundColor.startsWith('linear-gradient') ? '#ffffff' : selectedBackgroundColor} 
                onChange={(e) => onBackgroundColorChange(e.target.value)}
                className="w-6 h-6 rounded border border-gray-300 cursor-pointer hover:border-gray-400 transition-colors"
              />
              <div 
                className="w-6 h-6 rounded border border-gray-300"
                style={{ background: selectedBackgroundColor }}
                title="현재 선택된 배경"
              />
            </div>
            <span className="text-xs text-gray-600 font-mono truncate max-w-[120px]">
              {selectedBackgroundColor.startsWith('linear-gradient') ? '그라데이션' : selectedBackgroundColor}
            </span>
          </div>
          <div className="flex gap-1 mb-2 flex-wrap">
            {/* 단색 옵션 */}
            {[
              '#ffffff', '#f3f4f6', '#e5e7eb', '#3b82f6', '#10b981', '#f59e0b',
              '#ef4444', '#8b5cf6', '#ec4899', '#06b6d4', '#84cc16', '#000000'
            ].map(color => (
              <button
                key={color}
                onClick={() => onBackgroundColorChange(color)}
                className={`w-5 h-5 rounded border ${
                  selectedBackgroundColor === color ? 'border-gray-800 border-2' : 'border-gray-300'
                } hover:border-gray-600 transition-colors`}
                style={{ backgroundColor: color }}
                title={color}
              />
            ))}
            
            {/* 그라데이션 옵션 */}
            {[
              'linear-gradient(45deg, #667eea, #764ba2)',
              'linear-gradient(135deg, #667eea, #764ba2)',
              'linear-gradient(90deg, #ff9a9e, #fecfef)',
              'linear-gradient(45deg, #a8edea, #fed6e3)',
              'linear-gradient(135deg, #ffecd2, #fcb69f)',
              'linear-gradient(90deg, #a18cd1, #fbc2eb)',
              'linear-gradient(45deg, #fad0c4, #ffd1ff)',
              'linear-gradient(135deg, #ff9a9e, #fad0c4)'
            ].map((gradient, index) => (
              <button
                key={`gradient-${index}`}
                onClick={() => onBackgroundColorChange(gradient)}
                className={`w-5 h-5 rounded border ${
                  selectedBackgroundColor === gradient ? 'border-gray-800 border-2' : 'border-gray-300'
                } hover:border-gray-600 transition-colors`}
                style={{ background: gradient }}
                title="그라데이션"
              />
            ))}
          </div>
          <p className="form-help">
            배경이 제거된 이미지에 원하는 배경색을 입혀보세요.
          </p>
        </div>
      )}
    </div>
  );
};

export default AIResultsSection;
